<template>
  <div class="tabs" :class="{isRounded}">
    <div class="tabs__List">
      <div v-for="(item, index) in tabs" class="tabs__NavItem" :class="{'isActive': modelValue === item.value}">
        <input type="radio" :value="item.value" v-model="modelValue" :id="elementsIds[index]" />
        <label :for="elementsIds[index]">
          <template v-if="item.textIndentifier">
            {{ $t(`${item.textIndentifier}`) }} <span v-if="item.index">{{ item.index }}</span>
          </template>
          <template v-else>
            {{ item.title }}
          </template>
        </label>
      </div>
    </div>

    <div class="tabs__Content">
      <template v-for="item in tabs">
        <div v-show="modelValue === item.value" class="tabs__ContentItem">
          <slot :name="item.value" />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    tabs: {
      type: Array,
      required: true,
    },
    modelValue: {},
    rounded: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['update:modelValue']);
  const isRounded = computed(() => props.rounded);
  const elementsIds = ref([]);

  const modelValue = computed({
    get() {
      return props.modelValue || props.tabs[0].value;
    },
    set(value) {
      emit('update:modelValue', value);
      return value;
    }
  });

  for (const item in props.tabs) {
    elementsIds.value.push(useId());
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_tabs.scss');
</style>